import httpClient from "../http/http-client";
import { IPostTransaction, IPostTransactionFloorSpace } from './transaction.model';

export default class TransactionService {
  http;

  constructor() {
    this.http = httpClient
  }

  async postTransaction(transaction: IPostTransaction): Promise<IPostTransaction> {
    return this.http.post('transaction', transaction)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async postTransactionAverageFloorSpace(transaction: IPostTransaction): Promise<IPostTransactionFloorSpace> {
    return this.http.post('transaction/average-floor-space', transaction)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async createDirectEntryTransaction(details: any): Promise<any[]> {
    return this.http.post(`transaction/direct-entry`, details)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }
}